import { createAsyncThunk } from "@reduxjs/toolkit";
// import axios  from '../../services/utility';

import axios from "../../services/utilityNew";

const fetchYearData = createAsyncThunk("year/fetchYearData", async () => {
  const response = await axios.get(`v1.1/acad-year-master/public`);


  response.data.data = response?.data?.data?.filter((item) => item?.yearId !== 12);

  return response?.data;
});
const removeDateYear = createAsyncThunk(
  "year/removeYear",
  async () => {
    return [];
  }
);
export  {fetchYearData,removeDateYear};